import React, { Component } from 'react';
import { Icon, DatePicker } from 'antd';
import moment from 'moment';
import { flatten, uniq, isFunction } from 'lodash';

import { observer, inject } from 'mobx-react';

const { MonthPicker } = DatePicker;

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class NextMaintenanceFilter extends Component {
  keyStorageStart = `carFilter_startMonthToM`;
  keyStorageEnd = `carFilter_endMonthToM`;

  constructor(props) {
    super(props);

    let defaultState = {};
    const { filterStore } = this.props;
    let { selectedStartMonthToM } = filterStore.appliedFiltersParameters[this.keyStorageStart] || {};
    let { selectedEndMonthToM } = filterStore.appliedFiltersParameters[this.keyStorageEnd] || {};
    if (selectedStartMonthToM !== undefined || selectedEndMonthToM !== undefined) {
      defaultState = { ...defaultState, selectedStartMonthToM: moment(selectedStartMonthToM), selectedEndMonthToM: moment(selectedEndMonthToM) };
    }
    this.state = defaultState;
  }

  componentDidMount() {
    if (this.props.carsStore.cars) {
      this.init(this.props.carsStore.cars);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  init(cars) {
    this.setState({ cars }, () => {
      this.initMonthToM();
    });
  }

  initMonthToM = () => {
    const mm = uniq(
      flatten(this.props.carsStore.cars.filter(car => car.maintenances && car.maintenances.length > 0).map(car => car.maintenances)).map(maintenance => maintenance.date)
    ).sort((a, b) => {
      if (moment(a).isAfter(b)) {
        return 1;
      }
      if (moment(a).isBefore(b)) {
        return -1;
      }
      return 0;
    });
    this.setState({ startMonthToM: mm[0], endMonthToM: mm[mm.length - 1] });
  };

  selectStartMonthToM = selectedStartMonthToM => {
    const { filterStore } = this.props;
    this.setState({ selectedStartMonthToM: !!selectedStartMonthToM ? moment(selectedStartMonthToM).startOf('month') : null });
    let startMonth = selectedStartMonthToM ? car => (car.maintenances || []).some(m => moment(m.date).isSameOrAfter(selectedStartMonthToM)) : () => true;

    if (selectedStartMonthToM > 0) {
      filterStore.add('carFilter_startMonthToM', car => startMonth(car), undefined, {
        selectedStartMonthToM: selectedStartMonthToM.startOf('month').format()
      });
    } else {
      filterStore.remove('carFilter_startMonthToM');
    }
  };

  selectEndMonthToM = selectedEndMonthToM => {
    const { filterStore } = this.props;
    this.setState({ selectedEndMonthToM: !!selectedEndMonthToM ? moment(selectedEndMonthToM).endOf('month') : null });
    let endMonth = selectedEndMonthToM ? car => (car.maintenances || []).some(m => moment(m.date).isSameOrBefore(selectedEndMonthToM)) : () => true;
    if (selectedEndMonthToM > 0) {
      filterStore.add('carFilter_endMonthToM', car => endMonth(car), undefined, {
        selectedEndMonthToM: selectedEndMonthToM.endOf('month').format()
      });
    } else {
      filterStore.remove('carFilter_endMonthToM');
    }
  };

  removeNextMaintenance = () => {
    const { filterStore } = this.props;
    this.setState({ selectedStartMonthToM: null, selectedEndMonthToM: null });
    filterStore.remove('carFilter_startMonthToM');
    filterStore.remove('carFilter_endMonthToM');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        selectedStartMonthToM: null,
        selectedEndMonthToM: null
      });
    }
  };

  render() {
    const { selectedStartMonthToM, selectedEndMonthToM } = this.state;
    const { translationsStore, carsStore } = this.props;
    const { startMonthToM, endMonthToM } = carsStore;
    return (
      <div id="daysToMFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.maintenance')}
          <span>
            {!!selectedStartMonthToM && <span>{moment(selectedStartMonthToM).format(translationsStore.translate('format.YYYYMM'))}</span>}
            {!!selectedEndMonthToM && (
              <span>
                &nbsp;-&nbsp;
                {moment(selectedEndMonthToM).format(translationsStore.translate('format.YYYYMM'))}
              </span>
            )}
            {(!!selectedStartMonthToM || !!selectedEndMonthToM) && <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeNextMaintenance} />}
          </span>
        </div>
        <span>
          <MonthPicker
            disabledDate={aDate => aDate && ((!!selectedEndMonthToM && !!aDate.isAfter(selectedEndMonthToM)) || aDate.isBefore(startMonthToM))}
            value={selectedStartMonthToM}
            format={translationsStore.translate('format.YYYYMM')}
            onChange={this.selectStartMonthToM}
          />
          <MonthPicker
            disabledDate={aDate => aDate && ((!!selectedStartMonthToM && !!aDate.isBefore(selectedStartMonthToM)) || aDate.isAfter(endMonthToM))}
            value={selectedEndMonthToM}
            format={translationsStore.translate('format.YYYYMM')}
            onChange={this.selectEndMonthToM}
          />
        </span>
      </div>
    );
  }
}
